import axios, { AxiosInstance } from 'axios'
import { toast } from 'react-toastify'
import { LOCAL_EXECUTION } from '../utils/featureFlag'
import { Cookies } from 'react-cookie'
import { STORAGE_PREFIX } from '../config'

export const instanceAXIOS = axios.create({
  baseURL: process.env.REACT_APP_API_URL_PRODUTOR,
})

// Sessão expirada (401): avisa o usuário e manda de volta pro login (SSO).
// 401 = sessão/token inválido no backend; permissão negada vem como 400 (NOT_PERMITED),
// então não desloga por falta de permissão. A guarda evita redirecionamentos repetidos.
// Não intercepta os próprios endpoints de auth (login/refresh) nem a página /auth,
// para não sequestrar o fluxo de login nem causar loop de redirecionamento.
let handlingUnauthorized = false
instanceAXIOS.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    const reqUrl: string = error?.config?.url ?? ''
    const isAuthEndpoint = reqUrl.includes('auth/dashboard/producer')
    const onAuthPage = window.location.pathname.startsWith('/auth')
    if (status === 401 && !LOCAL_EXECUTION && !handlingUnauthorized && !isAuthEndpoint && !onAuthPage) {
      handlingUnauthorized = true
      toast.warn('Sua sessão expirou. Redirecionando para o login…')
      setTimeout(() => {
        // Always re-enter through the dashboard's own /auth route. Inside the
        // native WebView this lets the `get-user-token` bridge silently
        // re-acquire the token; /auth itself decides whether to fall back to
        // the external SSO login when there is genuinely no session.
        try {
          window.location.href = window.location.origin + '/auth'
        } catch {
          window.location.href = '/auth'
        }
      }, 1500)
    }
    return Promise.reject(error)
  },
)

export const APIDecoratorWithBaseURI = (
  base: string | undefined = process.env.REACT_APP_API_URL_PRODUTOR
): AxiosInstance => {
  instanceAXIOS.defaults.baseURL = base

  const key = STORAGE_PREFIX + 'userJWT'
  const cookies = new Cookies()
  const tokenFromStorage = cookies.get(key)

  const hasAuthToken = LOCAL_EXECUTION
  const accessToken = hasAuthToken
    ? process.env.REACT_APP_LOCAL_EXECUTION_TOKEN
    : tokenFromStorage

  instanceAXIOS.defaults.headers.common['Authorization'] = accessToken

  return instanceAXIOS
}

// @deprecated
interface Config {
  [key: string]: any
  AUTH_TOKEN?: string
}
// @deprecated
const config: Config = {}
// @deprecated
export const setConfig = (a: string, b: any): any => {
  config[a] = b
  return b
}
// @deprecated
export const getConfig = (): Config => config
